module.exports = __webpack_public_path__ + "img/headwayCapitalLogo.a36b5a96.png";